import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { ReportActions, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from '../ReportFormUi';
import '../../SchoolEventView.scss';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

//report 053
export function StudentTargetCompletionReportForm({ onCloseClick, onSubmit }: Props) {
  const requestInitial = {
    isShowCompleted: true,
    isShowUncompleted: true
  };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.STUDENT_TARGET_COMPLETION)}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>
            Review students added to this target checklist, their completion status, confirmation details, responsible
            staff member, and whether photo or video evidence has been added.
          </ReportDescription>

          <ReportSection
            number={1}
            title="Completion status"
            hint="Choose which target completion states should be included."
          >
            <ReportToggleList>
              <ReportToggle
                name="isShowCompleted"
                label="Show completed targets"
                hint="Include students who have been marked as having completed their target."
                value={values.isShowCompleted}
                onChange={value => setFieldValue('isShowCompleted', value)}
              />
              <ReportToggle
                name="isShowUncompleted"
                label="Show incomplete targets"
                hint="Include students who have not been marked as having completed their target."
                value={values.isShowUncompleted}
                onChange={value => setFieldValue('isShowUncompleted', value)}
              />
            </ReportToggleList>
          </ReportSection>

          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
